import * as yup from 'yup'
import { addressSchema, nameSchema } from './userSchema'

export const locationSchema = yup.object({
  address: addressSchema,
  country: yup.string().required('Country name is required'),
  name: nameSchema,
  state: yup.string().required('state name is required')
})
